import HeroCarousel from "@/pages/home/components/HeroCarousel";
import CategoryEntries from "@/pages/home/components/CategoryEntries";
import LatestSection from "@/pages/home/components/LatestSection";
import SiteIntro from "@/pages/home/components/SiteIntro";
import { useSeo } from "@/hooks/useSeo";

export default function Home() {
  useSeo({
    title: "台北娜娜品牌官网 - 时尚生活与潮流资讯平台",
    description:
      "台北娜娜官方网站，提供最新的时尚生活资讯、品牌动态和潮流趋势，致力于为用户打造优质的品牌体验，覆盖多元生活领域的丰富内容。",
    keywords: "台北娜娜,品牌官网,时尚生活,潮流资讯,品牌动态,生活方式,品牌展示",
  });

  return (
    <>
      <HeroCarousel />
      <CategoryEntries />
      <LatestSection />
      <SiteIntro />
    </>
  );
}